async function sendAuthorMessage(storyID, conversationID, userID, text) {
    const url = 'https://versify-back-b066d2bc73d1.herokuapp.com/sendAuthorMessage';
    const payload = {
        storyID: storyID,
        conversationID: conversationID,
        userID: userID,
        text: text
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();
        if (response.ok) {
            // console.log('Message added:', data.message);
        } else {
            // console.error('Error adding message:', data.error);
        }
    } catch (error) {
        // console.error('Failed to send author message:', error);
    }
}

export { sendAuthorMessage };
